module.exports = __webpack_public_path__ + "static/media/saayalogo.e1cf2d9b.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/saayalogo.png
// module id = 143
// module chunks = 1